export var PRIMARY_DISPLAY = 'primary';
//# sourceMappingURL=constants.js.map